<template>
  <div id="overview" class="row columns" v-html="content"></div>
</template>

<script>
  export default {
    name: 'Overview',
    data() {
      return {
        content: `<div class="small-12 columns">
  <h1>Welcome</h1>
  <p>This is overview page for your EPP API administration.</p>
  <p>To edit this text, please create a <code>overview.html</code> file in the <code>static</code> directory.</p>
  <p>Note that you should use direct HTML content without <code>html</code>, <code>head</code> or <code>body</code> tags.</p>
  <p>You can also change the file to be used by editing the <code>window.EPPConfig.overview</code> value in your <code>index.html</code> file.</p>
</div>`
      }
    },
    created() {
      let config = window.EPPConfig || { overview: null };
      if (config.hasOwnProperty("overview") && typeof config.overview === "string") {
        this.content = config.overview;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/Overview.vue